import React, { useContext, useEffect, useState } from 'react'
import { BiCheck } from 'react-icons/bi'
import Renderif from '../../components/renderif';
import { useNavigate } from 'react-router-dom';
import SideMenu from '../../components/sidemenu';
import AgendarCita from './agendar_client';
import Quiz from '../../components/quiz';
import BVCalendar from '../../components/calendar';
import { gray10, gray20, gray30, gray40, gray70, gray100, primary } from '../../utils/colors';
import { AuthContext } from '../../context/auth_context';
import { AlertContext } from '../../context/alert_context'
import { Service } from '../../services/api';
import SelectProfile from './select_profile_client';



export default function AgendarCitaView() {
    const navigate = useNavigate();
    const { user, logout } = useContext(AuthContext)
    const { notify } = useContext(AlertContext)
    console.log(user);

    let date = new Date();
    date.setDate(date.getDate() + 1)


    const [state, setState] = useState({
        step: 0,
        show_agendar_cita: false,
        show_select_profile: false,
        show_onboarding: user.onboarding === "" || user.onboarding === null ? true : false,
        tips: [],
        appoiment: [],
        appoiment_type: "",
        specialists: [],
        specialists_pisco: [],
        specialists_couch: [],
        speciality: "",
        specialist_selected: null,
        selected_specialist: null,
        selected_day: date,
        busy: [],
        available: null,
        hours: [],
        selected_time: '',
        selected_daytime: null,
        family: [],
        selected_family: [],
    })



    useEffect(() => {

        const init = async () => {
            // const psico = await Service('GET', 'Appointment/specialist/1')
            // console.log(psico)
            const couch = await Service('GET', 'Appointment/specialist/2')
            console.log(couch.data.filter((couch) => couch.id !== "aa534137-f287-48b2-866a-f2816973f335"))
            const family = await Service('GET', 'Family');
            console.log(family)
            //CONSULTAR EL HORARIO DEL ESPECIALISTA Y ASIGNAR EL HOARIOS AL ESTADO, AVAILABLE

            setState({
                ...state,
                // available:respuesta
                // specialists_pisco: psico.data,
                specialists_couch: couch.data.filter((couch) => couch.id !== "aa534137-f287-48b2-866a-f2816973f335" && couch.id !== "39951cfb-db8e-458a-bd45-1e008e1a92bd" && couch.id !== "4346535a-79ea-4756-994e-d14d937093df"),
                // specialists: [...psico.data, ...couch.data]
                specialists: [...couch.data.filter((couch) => couch.id !== "aa534137-f287-48b2-866a-f2816973f335" && couch.id !== "39951cfb-db8e-458a-bd45-1e008e1a92bd" && couch.id !== "4346535a-79ea-4756-994e-d14d937093df")],
                family: family.data
            })
        };
        init();
        return () => { }
    }, [])

    Number.prototype.pad = function (size) {
        var s = String(this);
        while (s.length < (size || 2)) { s = "0" + s; }
        return s;
    }

    const _schedule = async () => {

        setState({ ...state, loading: true })


        try {
            var start = new Date(state.selected_daytime);

            var day = start.getDate();
            var month = start.getMonth() + 1; //months are zero based
            var year = start.getFullYear();
            const time = start.toLocaleTimeString('es-ES').replace(/(.*)\D\d+/, '$1');
            let date_parsed = year + '-' + month.pad() + '-' + day.pad() + 'T' + time + ':00.000Z';



            let body = {
                userId: user.id,
                specialistId: state.selected_specialist.id,
                date: date_parsed,
                description: "Cita Bien Vivir",
                // description: state.description,
            }
            // console.log(body);
            const schedule = await Service('POST', 'Appointment', body);

            if (schedule?.status === 200) {
                notify({ title: 'Listo!', message: 'Se ha agendado un nueva cita.', type: 'success' })
                navigate('/client')

            } else {
                notify({ title: 'Error!', message: 'No se puede agendar una cita en este momento.', type: 'error' })

            }

        } catch (error) {
            console.log(error)
            notify({ title: 'Error!', message: 'Al conectar con Google Calendar.', type: 'error' })
        }


    }

    const _scheduleFamiliar = async () => {


        setState({ ...state, loading: true })


        try {
            const start = new Date(state.selected_daytime);
            const end = new Date(state.selected_daytime.setHours(state.selected_daytime.getHours() + 1));
            // const res = await apiCalendar.handleAuthClick();

            var day = start.getDate();
            var month = start.getMonth() + 1; //months are zero based
            var year = start.getFullYear();
            const time = start.toLocaleTimeString('es-ES').replace(/(.*)\D\d+/, '$1');
            let date_parsed = year + '-' + month.pad() + '-' + day.pad() + 'T' + time + ':00.000Z';


            let familyMembers = [];
            state.selected_family.map((item) => {
                familyMembers.push(item.id)
            })
            let body = {
                userId: user.id,
                specialistId: state.selected_specialist.id,
                date: date_parsed,
                description: "Cita Bien Vivir",
                familyMembers
            }
            // console.log(body)

            const schedule = await Service('POST', 'Appointment/family', body);

            if (schedule?.status === 200) {
                notify({ title: 'Listo!', message: 'Se ha agendado un nueva cita.', type: 'success' })

            } else {
                notify({ title: 'Error!', message: 'No se puede agendar una cita en este momento.', type: 'error' })
            }



        } catch (error) {
            console.log(error)
            notify({ title: 'Error!', message: 'Al conectar con Google Calendar.', type: 'error' })
        }


    }

    var weekday = new Array(7);
    weekday[0] = "Domingo";
    weekday[1] = "Lunes";
    weekday[2] = "Martes";
    weekday[3] = "Miercoles";
    weekday[4] = "Jueves";
    weekday[5] = "Viernes";
    weekday[6] = "Sabado";

    var weekday_en = new Array(7);
    weekday_en[0] = "Sunday";
    weekday_en[1] = "Monday";
    weekday_en[2] = "Tuesday";
    weekday_en[3] = "Wednesday";
    weekday_en[4] = "Thursday";
    weekday_en[5] = "Friday";
    weekday_en[6] = "Saturday";

    var months = new Array(7);
    months[0] = "Enero";
    months[1] = "Febrero";
    months[2] = "Marzo";
    months[3] = "Abril";
    months[4] = "Mayo";
    months[5] = "Junio";
    months[6] = "Julio";
    months[7] = "Agosto";
    months[8] = "Septiembre";
    months[9] = "Octubre";
    months[10] = "Noviembre";
    months[11] = "Diciembre";

    return (
        <>
            {/* <AlertNotification></AlertNotification> */}



            <Renderif isTrue={state.show_agendar_cita}>
                <AgendarCita onSchedule={(cita) => { }} onCancel={() => {
                    setState({ ...state, show_agendar_cita: false })
                }}></AgendarCita>
            </Renderif>

            <Renderif isTrue={state.show_onboarding}>
                <Quiz onClose={() => {
                    setState({ ...state, show_onboarding: false })
                }}></Quiz>
            </Renderif>

            <Renderif isTrue={state.show_select_profile}>
                <SelectProfile onCancel={() => {
                    setState({ ...state, show_select_profile: false })
                }}></SelectProfile>
            </Renderif>

            <div className='container-fluid d-flex h-100 bacground-gray'>

                <SideMenu></SideMenu>

                <div className='col pb-5 hide-scroll overflow-auto'>

                    <div className='row'>

                        <div className='p-2 bg-black border-b flex-center'>


                            <div className='col-8 flex-center-j-right'>
                                <div className='d-flex py-1 py-sm-2 order-0 order-md-1'>
                                    <div className='pe-2 flex-center'>
                                        <div className='bv-cta-curve bv-cta--primary-gray-20 bv-icon bv-icon--mid txt-white' onClick={() => {
                                            navigate('/client')
                                        }}>
                                            Cancelar
                                        </div>
                                    </div>
                                    <div className='pe-2 flex-center'>
                                        <div className='bv-cta-curve bv-cta--primary-white bv-icon bv-icon--mid' onClick={() => {
                                            if (state.appoiment_type === "PERSONAL" && state.step === 5) {
                                                _schedule()
                                            } else if (state.appoiment_type === "FAMILIAR" && state.step === 5) {
                                                _scheduleFamiliar()
                                            }
                                            else {
                                                notify({ title: 'Aviso!', message: 'Aún faltan opciones por seleccionar.', type: 'error' })
                                            }

                                        }}>
                                            Agendar
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>


                        {/* <div className='p-1'>
                            <Slider></Slider>
                        </div> */}


                    </div>

                    <div className='row'>
                        <div className='col-md-2 col-sm-1'>

                        </div>
                        <div className='col-md-8 col-sm-9'>
                            <div className='bold h4 my-4 px-3'>
                                Agendar cita
                            </div>

                            <div className='px-3 bv-card'>
                                <div className='bold h5 my-3'>
                                    Tipo de cita
                                </div>
                                <div className='d-flex mb-3'>
                                    <div className='pe-2 flex-center'>
                                        <div className={`bv-cta-curve bv-cta--option bv-icon bv-icon--mid ${state.appoiment_type === "PERSONAL" ? 'bv-tab--active' : ''}`} onClick={() => {
                                            setState({ ...state, appoiment_type: "PERSONAL", step: 2 })
                                        }}>
                                            Personal
                                        </div>
                                    </div>
                                    <div className='pe-2 flex-center'>
                                        <div className={`bv-cta-curve bv-cta--option bv-icon bv-icon--mid ${state.appoiment_type === "FAMILIAR" ? 'bv-tab--active' : ''}`} onClick={() => {
                                            setState({ ...state, appoiment_type: "FAMILIAR", step: 1 })
                                        }}>
                                            Familiar
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Renderif isTrue={state.step >= 1 && state.appoiment_type === "FAMILIAR"}>
                                <div className='px-3 bv-card my-4'>
                                    <div className='bold h5 my-3'>
                                        Familiar
                                    </div>
                                    <div className='mb-4'>
                                        <div className='d-flex flex-wrap gap-3'>
                                            {
                                                state.family.map((item, i) => {

                                                    return (

                                                        <div key={i} className={`option-size bv-card-left bv-cta--option ${state.selected_family.some((member) => member.id === item.id) === true ? 'bv-tab--active' : ''}`} onClick={async () => {
                                                            state.step = 2;
                                                            if (state.selected_family.some((member) => member.id === item.id)) {

                                                                state.selected_family = state.selected_family.filter((member) => member.id !== item.id);
                                                            } else {
                                                                state.selected_family.push(item);
                                                            }
                                                            setState({ ...state })
                                                        }}>
                                                            <div className='flex-center'>
                                                                <div className='avatar-profile bv-cta--option ms-3'></div>
                                                            </div>
                                                            <div className='p-2'>
                                                                <div className='bold f-14'>
                                                                    {item?.firstName} {item?.lastName}
                                                                </div>
                                                                <div className='f-12 my-1 text-gray'>
                                                                    {item?.relationType}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Renderif>

                            <Renderif isTrue={state.step >= 2}>
                                <div className='px-3 bv-card my-4'>
                                    <div className='bold h5 my-3'>
                                        Especialidad
                                    </div>
                                    <div className='d-flex mb-3'>
                                        <div className='pe-2 flex-center'>
                                            <div className={`bv-cta-curve bv-cta--option bv-icon bv-icon--mid ${state.speciality === "COUCH" ? 'bv-tab--active' : ''}`} onClick={() => {
                                                setState({ ...state, speciality: "COUCH", step: 3 })
                                            }}>
                                                Coach
                                            </div>
                                        </div>
                                        <div className='pe-2 flex-center'>
                                            <div className={`bv-cta-curve bv-cta--option bv-icon bv-icon--mid ${state.speciality === "PSYCOLOGY" ? 'bv-tab--active' : ''}`} onClick={() => {
                                                setState({ ...state, speciality: "PSYCOLOGY", step: 3 })
                                            }}>
                                                Psicología
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Renderif>


                            <Renderif isTrue={state.step >= 3}>
                                <div className='px-3 bv-card my-4'>
                                    <div className='bold h5 my-3'>
                                        Profesional
                                    </div>
                                    <div className='mb-4'>
                                        <div className='d-flex flex-wrap gap-3'>
                                            {
                                                state.specialists.map((item, i) => {

                                                    return (

                                                        <div key={i} className={`option-size bv-card-left bv-cta--option ${state.specialist_selected === i ? 'bv-tab--active' : ''}`} onClick={async () => {
                                                            // console.log(item)
                                                            let _available = await Service('GET', `Appointment/dates-labor/${item.id}`)
                                                            // console.log(_available)
                                                            let _busy = await Service('GET', `Appointment/dates-busy/${item.id}`)
                                                            // console.log(_busy)
                                                            setState({ ...state, specialist_selected: i, selected_specialist: item, available: _available.data, busy: _busy.data, step: 4 })
                                                        }}>
                                                            <div className='flex-center'>
                                                                <div className='avatar-profile bv-cta--option ms-3'></div>
                                                            </div>
                                                            <div className='p-2'>
                                                                <div className='bold f-14'>
                                                                    Dr {item?.firstName} {item?.lastName}
                                                                </div>
                                                                <div className='f-12 my-1 text-gray'>
                                                                    Psícologo
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                            </Renderif>

                            <Renderif isTrue={state.step >= 4}>
                                <div className='px-3 bv-card my-4'>
                                    <div className='bold h5 my-3'>
                                        Cita
                                    </div>
                                    Selecciona la fecha y hora de tu cita
                                    <div className='d-sm-flex overflow-hidden py-2 px-4'>

                                        <div className='col'>
                                            <BVCalendar init={date} onChange={(evt) => {

                                                let y = evt.getFullYear()
                                                let m = (evt.getMonth() + 1) < 10 ? '0' + (evt.getMonth() + 1) : (evt.getMonth() + 1)
                                                let d = evt.getDate() < 10 ? '0' + evt.getDate() : evt.getDate()

                                                console.log(y + "-" + m + "-" + d)

                                                let _busy = []
                                                state.busy.map((busy_date) => {
                                                    // console.log(busy_date.split('T')[0])
                                                    if (busy_date.split('T')[0] === y + "-" + m + "-" + d) {
                                                        console.log("CITAS EN ESE DIA, VALIDAR HORARIO")
                                                        _busy.push(busy_date.split('T')[1])
                                                    }
                                                })


                                                let day = weekday_en[evt.getDay()]
                                                let horarios = state.available?.filter((item) => item.dayOfWeek === day)[0]?.timeRanges

                                                let hours = []

                                                horarios?.map((horario) => {
                                                    console.log(horario)
                                                    let start = horario.startTime;
                                                    let end = horario.endTime;


                                                    let time_start = new Date();
                                                    time_start.setHours(start.split(':')[0], start.split(':')[1], start.split(':')[2])

                                                    let time_end = new Date();
                                                    time_end.setHours(end.split(':')[0], end.split(':')[1], end.split(':')[2])



                                                    let hora = new Date();
                                                    for (let i = time_start.getHours(); i <= time_end.getHours() - 1; i++) {

                                                        hora.setHours(i, start.split(':')[1], '00')
                                                        let h = hora.getHours() >= 10 ? hora.getHours() : '0' + hora.getHours()
                                                        let m = hora.getMinutes() >= 10 ? hora.getMinutes() : '0' + hora.getMinutes()
                                                        let hm = h + ':' + m;
                                                        console.log(hm)
                                                        console.log(_busy)
                                                        if (!_busy.includes(hm + ":00")) {
                                                            hours.push(hm)
                                                        }


                                                    }



                                                })
                                                // console.log(hours)

                                                // let time = new Date();
                                                // time.setHours(time.getHours() + 1)

                                                // console.log(time)



                                                setState({ ...state, selected_day: evt, hours })

                                            }}></BVCalendar>
                                        </div>


                                        <div className='col overflow-auto hide-scroll ps-3'>

                                            <Renderif isTrue={state.selected_day < new Date()}>
                                                <div className='f-14 bold text-gray'>En BienVivir, programar citas solo es posible a partir del día siguiente.</div>
                                            </Renderif>
                                            <Renderif isTrue={state.hours.length === 0}>
                                                <div className='f-14 bold text-gray'>No hay horarios dispobibles</div>
                                            </Renderif>

                                            <Renderif isTrue={state.selected_day > new Date()}>
                                                {
                                                    state.hours.map((item, i) => {
                                                        // console.log(state.selected_day)
                                                        return (
                                                            <div key={i} className={`d-flex align-items-center justify-content-center py-2 b-bottom ps-1 highlight-hover ${state.selected_time === i ? 'highlight-active' : ''}`} onClick={() => {
                                                                let daytime = new Date(new Date(state.selected_day).setHours(item.split(':')[0], item.split(':')[1], '00'));
                                                                console.log(daytime.getDate())




                                                                setState({ ...state, selected_time: i, selected_daytime: daytime, step: 5 })
                                                            }}>
                                                                <div className='col f-12 text-gray'>{weekday[new Date(state.selected_day).getDay()]} {new Date(state.selected_day).getDate()}</div>
                                                                <div className='col f-12 text-gray'>{months[new Date(state.selected_day).getMonth()]} {new Date(state.selected_day).getFullYear()}</div>
                                                                <div className='col f-12 text-gray'>{item}</div>
                                                                <div className='bv-icon bv-icon--mid me-2'>
                                                                    <BiCheck size={28} color={`${state.selected_time === i ? '#0972CE' : 'transparent'}`}></BiCheck>
                                                                </div>
                                                                {/* <div className={`bv-pill cursor-pointer ${i === 0 ? 'bv-pill--primary':'bv-pill--gray'}`}>Seleccionar</div> */}
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </Renderif>


                                        </div>
                                    </div>
                                </div>
                            </Renderif>
                            <Renderif isTrue={state.step >= 5}>
                                <div className='px-3 my-4'>
                                    <div className='flex-center-j-right'>
                                        <div className='pe-2 flex-center'>
                                            <div className='bv-cta-curve bv-cta--primary-gray-20 bv-icon bv-icon--mid txt-white' onClick={() => {
                                                navigate('/client')
                                            }}>
                                                Cancelar
                                            </div>
                                        </div>
                                        <div className='pe-2 flex-center'>
                                            <div className='bv-cta-curve bv-cta--primary-black bv-icon bv-icon--mid txt-white' onClick={() => {
                                                if (state.appoiment_type === "PERSONAL" && state.step === 5) {
                                                    _schedule()
                                                } else if (state.appoiment_type === "FAMILIAR" && state.step === 5) {
                                                    _scheduleFamiliar()
                                                }
                                                else {
                                                    notify({ title: 'Aviso!', message: 'Aún faltan opciones por seleccionar.', type: 'error' })
                                                }

                                            }}>
                                                Agendar
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </Renderif>

                        </div>
                        <div className='col-md-2 col-sm-1'>

                        </div>

                    </div>

                </div>







            </div>
        </>
    )
}
